import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: boolean = false;

export const mobileViewSlice = createSlice({
  name: 'mobileView',
  initialState,
  reducers: {
    setMobileView: (state, action: PayloadAction<boolean>) => {
      return action.payload;
    }
  }
});

export const { setMobileView } = mobileViewSlice.actions;
export default mobileViewSlice.reducer;
